import { useEffect, useState } from 'react'
import style from './geral.module.css'
import { useAuth } from '../../../hooks/AuthContext'
import { useNavigate } from 'react-router-dom'
import RankingRelatorio from './RankingRelatorio'
import Button from '../../layout/Button/Button'
import { useToast } from '../../../hooks/Toast'
import { gerarRelatoriosDoMes, buscarRelatoriosDoMes, montarCrescimentoDoMes } from '../../../firebase/relatorios'
import RelatorioMensalTabelas from '../../layout/RelatorioMensalTabelas'


export default function RelatorioMensal(){

    const {usuario} = useAuth()
    const {mostrarAviso} = useToast()
    const [relatorios,setRelatorios]= useState()
    const [relatorioCrescimento, setRelatorioCrescimento] = useState()
    const [gerandoRetroativo, setGerandoRetroativo] = useState(false)
    const [resultadoRetroativo, setResultadoRetroativo] = useState(null)
    const navigate = useNavigate()

    // Requisito do README: "possibilidade de gerar um relatório do mês
    // anterior (caso esteja faltando)". Botão manual do diretor — roda a
    // mesma agregação de RelatorioDetalhado.js (via montarRelatorioDeAula,
    // agora compartilhada) sobre os dados já existentes de aulas/aulaTurma
    // do mês passado, para os dias que ainda não tiverem um `relatorio`
    // salvo. Ver src/firebase/relatorios.js.
    const gerarRelatorioMesAnterior = async ()=>{
        if(gerandoRetroativo) return
        setGerandoRetroativo(true)
        setResultadoRetroativo(null)
        try {
            const hoje = new Date()
            // Mês anterior ao atual, com virada de ano (janeiro -> dezembro do ano passado).
            const mesAlvo = hoje.getMonth() === 0 ? 12 : hoje.getMonth()
            const anoAlvo = hoje.getMonth() === 0 ? hoje.getFullYear() - 1 : hoje.getFullYear()

            const resultado = await gerarRelatoriosDoMes(usuario.idEscola, mesAlvo, anoAlvo)
            setResultadoRetroativo({...resultado, mes: mesAlvo, ano: anoAlvo})

            if(resultado.avisoGeral){
                mostrarAviso(resultado.avisoGeral, 'erro')
            } else if(resultado.geradas.length > 0){
                mostrarAviso(`${resultado.geradas.length} relatório(s) gerado(s) para ${mesAlvo}/${anoAlvo}`, 'sucesso')
            } else {
                mostrarAviso('Nenhum relatório novo para gerar — já estava tudo em dia', 'sucesso')
            }
        } catch (error) {
            mostrarAviso('Erro ao gerar relatório do mês anterior: ' + error.message, 'erro')
        } finally {
            setGerandoRetroativo(false)
        }
    }
    useEffect(()=>{
        const hoje = new Date()
        const mes = hoje.getMonth() + 1
        const ano = hoje.getFullYear()

        buscarRelatoriosDoMes(usuario.idEscola, mes, ano).then((docs)=>{
            if(!docs || docs.length < 1){
                alert("Não foi gerado nenhum relatório nesse mês")
                return navigate(-1,{replace:true})
            }
            const resultado = montarCrescimentoDoMes(docs)
            setRelatorioCrescimento(resultado.crescimento)
            setRelatorios(resultado.diasOrdenados)
        })
    },[])
    
    return(
        <section className={`${style.container}`}>

            <h3>Relatorios e estatísticas</h3>
                <section>
                    <div style={{display:"flex",width:"100%",justifyContent:"center",flexDirection:"column",alignItems:"center",gap:"8px"}}>
                        <Button onClick={gerarRelatorioMesAnterior} disabled={gerandoRetroativo}>
                            {gerandoRetroativo ? 'Gerando...' : 'Gerar relatório do mês anterior (se estiver faltando)'}
                        </Button>
                        {resultadoRetroativo && (
                            <div style={{fontSize:"14px",textAlign:"center"}}>
                                {resultadoRetroativo.avisoGeral && <p>{resultadoRetroativo.avisoGeral}</p>}
                                {!resultadoRetroativo.avisoGeral && <>
                                    <p>Mês {resultadoRetroativo.mes}/{resultadoRetroativo.ano}: {resultadoRetroativo.geradas.length} gerado(s), {resultadoRetroativo.puladas.length} pulado(s), {resultadoRetroativo.erros.length} erro(s).</p>
                                    {resultadoRetroativo.puladas.length > 0 && (
                                        <ul style={{textAlign:"left"}}>
                                            {resultadoRetroativo.puladas.map((p,i)=>(
                                                <li key={i}>Dia {p.dia}: {p.motivo}</li>
                                            ))}
                                        </ul>
                                    )}
                                </>}
                            </div>
                        )}
                    </div>
                    <div className={`${style.geralList}`}>
                        {relatorios && (
                            <RelatorioMensalTabelas
                                diasOrdenados={relatorios}
                                crescimento={relatorioCrescimento}
                                mes={relatorios[0].data.mes}
                            />
                        )}
                    </div>
                </section>
                {/* NOVO: ranking de turmas (percentual/oferta) e alunos
                    (pontos/presença), com filtro por trimestre para alunos. */}
                <RankingRelatorio/>
        </section>
    )
}